import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportProcessosRiscosUseCase } from "../../../presentation/useCases/read/get_report_procesos_riscos_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportProcessosRiscosUseCase implements IGetReportProcessosRiscosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportProcessosRiscos(
    requiredMimeType: ReportMimeType | null, IdItemProcesso: number
  ): Promise<ReportData> {
    const response = await this.repository.getReportProcessosRiscos(
      requiredMimeType, IdItemProcesso
    );

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `procesos_riscos_${IdItemProcesso}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
